export default __webpack_public_path__ + "poppins-regular-webfont.woff2";